<template>
  <div ref="scrollRef" class="contentRef">

    <el-col :span="20" :offset="2">
      <!-- <el-card class="box-card"> -->
      <div class="right-action">
        <el-button @click="goBack('ruleForm')">返回</el-button>
      </div>
      <div class="textAlign marginTop10">
        <h2>评价订单</h2>
        <p class="marginTop10">
          <span class="color197">订单编号：</span>{{ orderDetail.orderSn }} &nbsp;&nbsp;&nbsp;
          <span class="color197">{{ orderDetail.createTime }}</span>
        </p>
      </div>
      <el-row class="marginTop10 markRow" type="flex" align="middle">
        <el-col :span="5" class="textAlign markLeft">
          <el-image
            style="width: 100px; height: 100px; cursor: pointer"
            :src="orderDetail.productPic"
            @click="handleShop(orderDetail)"
          />
          <div class="marginTop10 font14">{{ orderDetail.productName }}</div>
          <div class="marginTop10 color197">{{ orderDetail.productAttr | formatProductAttr }}</div>
        </el-col>
        <el-col :span="1" class="markCenter" />
        <el-col :span="18">
          <el-form ref="ruleForm" label-position="right" :model="markForm" :rules="markRules" label-width="100px">
            <el-form-item label="商品评分" :label-width="formLabelWidth" prop="star">
              <el-col :span="20" :offset="1" style="padding-top: 8px">
                <el-rate v-model="markForm.star" show-text :texts="texts" />
              </el-col>
            </el-form-item>
            <el-form-item label="评价晒单" :label-width="formLabelWidth" prop="content">
              <el-col :span="20" :offset="1">
                <el-input
                  v-model="markForm.content"
                  type="textarea"
                  :rows="6"
                  :maxlength="500"
                  placeholder="分享体验心得，给万千想买的人一个参考，请遵守国家法律法规"
                />
              </el-col>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div class="textAlign">
        <span class="markBtn" @click="handlemark('ruleForm')">发 表</span>
        <span class="anonymity">
          <el-checkbox v-model="isSecret" />&nbsp;&nbsp;
          <span class="colorRed" @click="specificBook">匿名评价</span>
        </span>
      </div>
      <!-- </el-card> -->
    </el-col>
  </div>
</template>
<script>
import { comment, commentItemDetail } from '@/api/evaluate.js'
import { productDetailHaveLoggedIn } from '@/api/product'
const defaultForm = {
  star: null,
  content: null
}
export default {
  name: 'EvaluateEdit',
  filters: {
    formatStatus(type) {
      if (type === 0) {
        return '待审核'
      } else if (type === 1) {
        return '审核通过'
      } else if (type === 2) {
        return '审核驳回'
      }
    },
    formatTime(time) {
      const dateString = time
      const date = new Date(dateString)
      const year = date.getFullYear()
      let month = date.getMonth() + 1 // getMonth() 返回的月份从0开始，所以需要+1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      // 为了保持两位数，当小于10的时候，前面补0
      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second
      return `${year}-${month}-${day}  ${hour}:${minute}:${second}`
    },
    formatProductAttr(value) {
      if (value == null) {
        return ''
      } else {
        const attr = JSON.parse(value)
        let result = ''
        for (let i = 0; i < attr.length; i++) {
          result += attr[i].key
          result += ':  '
          result += attr[i].value
          result += ';'
        }
        return result
      }
    }
  },
  data() {
    // const validateRepeat = (rule, value, callback) => {
    //   if (value < 1) {
    //     return callback(new Error('请选择商品评分'))
    //   }
    //   callback()
    // }
    return {
      formLabelWidth: '160px',
      markForm: Object.assign({}, defaultForm),
      dialogFormVisible: false,
      markRules: {
        star: [
          { required: true, message: '请选择商品评分', trigger: 'blue' }
          // { validator: validateRepeat, trigger: 'blue' }
        ]
      },
      isSecret: true,
      texts: ['非常不满意', '不满意', '一般', '满意', '非常满意'],
      id: null,
      orderDetail: {}
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log('1213211', to, from,)
  //   window.scrollTo(0, 0)
  //   next()
  // },
  created() {

    // this.$refs.scrollRef.scrollTop = 0
  },
  mounted() {
    setTimeout(() => {
      this.$refs.scrollRef.scrollTo(0, 0)
    }, 3000)
    // console.log('this.$refs.scrollRef.scrollTop', this.$refs.scrollRef.scrollTop,)
    this.id = this.$route.query.id
    this.getCommentItemDetail(this.id)
  },
  methods: {
    getCommentItemDetail(id) {
      commentItemDetail({ id: id }).then(res => {
        this.orderDetail = res.data
      })
    },
    // 取消
    goBack(formName) {
      this.markForm = Object.assign({}, defaultForm)// 清空表单数据
      this.dialogFormVisible = false
      this.$refs[formName].resetFields()
      this.$refs[formName].clearValidate()
      this.$router.push({
        name: 'evaluate'
      })
    },
    // 确认
    handlemark(formName) {
      if (this.markForm.star < 1) {
        this.$message.warning('请选择商品评分')
        return false
      }
      // console.log(this.markForm.star)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let isSecret
          if (this.isSecret) {
            isSecret = 1
          } else {
            isSecret = 0
          }
          const params = {
            content: this.markForm.content,
            star: this.markForm.star,
            isSecret: isSecret,
            orderItemId: this.id
          }
          comment(params).then(res => {
            if (res.code === 200) {
              this.$message.success('发表成功')
              this.markForm = Object.assign({}, defaultForm)// 清空表单数据
              this.dialogFormVisible = false
              this.$refs[formName].clearValidate()
              this.$router.push({
                name: 'evaluate'
              })
            }
          })
        }
      })
    },
    specificBook() {
      this.isSecret = !this.isSecret
    },
    // 跳转商品详情
    handleShop(val) {
      // console.log(val)
      productDetailHaveLoggedIn(val.productId).then(res => {
        if (res.code === 200) {
          this.$router.push({
            path: '/goodsDetail',
            query: {
              id: val.productId
            }
          })
        }
      })
    }
  }
}
</script>

<style>
.font14{
  font-size: 14px;
}
.color197{
  color: rgb(197, 197, 197);;
}
.textAlign{
  text-align: center;
}
.marginTop10{
  margin-top: 10px;
}
.marginTop20{
  margin-top: 20px;
}
.marginTop30{
  margin-top: 30px;
}
.markLeft{
  /* border-right: solid 1px #eee;
  height: 100%; */
}
.markCenter{
  border-right: solid 1px #eee;
  height: 100%;
}
.markRow{
  height: 300px;
}
.markBtn{
    cursor: pointer;
    color: #fff;
    width: 180px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: rgb(245, 120, 12);
    display: inline-block;
}
.anonymity{
  margin-left: 24px;
}
.box-card{
  margin-top: 30px;
}
.right-action {
  display: flex;
  align-items: flex-end;
  justify-content: right;
}
.colorRed {
  cursor: pointer;
}
::v-deep .ivu-layout.ivu-layout-has-sider>.ivu-layout, .ivu-layout.ivu-layout-has-sider>.ivu-layout-content {
  overflow-x: auto;
}
.contentRef{
  overflow: none !important;
}
</style>
